module.exports = __webpack_public_path__ + "static/media/icon_word.1304e793.png";